import { StyleSheet, Platform } from "react-native";
import AppTheme from "../../AppTheme";

const hoursStyles = StyleSheet.create({
  daysContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  tile: {
    width: 40,
    height: 40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  numbers: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "row",
    paddingVertical: 10,
    paddingHorizontal: 6,
    minWidth: 34,
  },
  hoursText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 13,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  minutesText: {
    fontWeight: "400",
    fontSize: 9,
  },
  dayText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.title,
  },
});

export default hoursStyles;
